import {Component, Input, OnInit} from '@angular/core';
import {AccountManagerService} from "../../services/account-manager-service";
import {MaintenanceStatus} from "../../models/maintenance";

@Component({
  selector: 'app-assistance-request',
  templateUrl: './assistance-request.component.html',
  styleUrls: ['./assistance-request.component.scss']
})
export class AssistanceRequestComponent implements OnInit {

  @Input()
  isLoading: boolean;

  @Input()
  serial: string;

  @Input()
  equipmentName: string;

  @Input()
  name: string;

  @Input()
  requesterName: string;

  @Input()
  date: Date;

  @Input()
  status: MaintenanceStatus;

  @Input()
  operatorId: string;

  @Input()
  isSelected: boolean;

  constructor(
    private accountManager: AccountManagerService
  ) { }

  ngOnInit(): void {
  }

  getMaintenanceStatuses() {
    return MaintenanceStatus;
  }

  isTakenByMe() {
    return this.operatorId == this.accountManager.account.id;
  }

}
